/**
 * Pure helper functions extracted from register_bid_controller.js
 */

export function validateRegistrationForm({ phone, cedula }) {
  const errors = []
  if (!phone) errors.push("Ingresa tu numero de telefono.")
  if (!cedula) errors.push("Ingresa tu cedula.")
  return errors
}

export function formatRegistrationErrors(errors) {
  if (!errors || !Array.isArray(errors) || errors.length === 0) {
    return ''
  }
  return errors.join(' ')
}
